import "../../styles/blocks/app/app-features.scss";
import "../../styles/blocks/app/app-feature.scss";

import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage as Image } from "gatsby-plugin-image";

const AppFeatures = ({ features }) => {
	return (
		<div className="app-feature">
			<div className="app-feature__container container">
				<div className="app-feature__row">
					{features.map(({ image, title, content }, index) => {
						const imageData = image?.localFile?.childImageSharp?.gatsbyImageData;
						const imageAlt = image?.altText || title;
						return (
							<div
								className="app-feature__item"
								key={index}
							>
								<div className="app-feature__item-wrapper">
									<div className="app-feature__item-image-wrapper">
										{imageData ? (
											<Image
												className="app-feature__image"
												image={imageData}
												alt={imageAlt}
												title={imageAlt}
											/>
										) : null}
									</div>

									<h4 className="app-feature__item-title">
										{title}
									</h4>

									<div className="app-feature__item-content">
										{content}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}

AppFeatures.propTypes = {
	features: PropTypes.array.isRequired
};

export default AppFeatures;
